// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5697f46b","47":"dfe1b5c3","197":"30064cfa","245":"b46b05d0","300":"0182fa0c","363":"12fcff8b","374":"99c9dec8","436":"af36f2c2","486":"9530f2f5","542":"8ecfd2a2","681":"29ee29af","714":"e75f64ea","841":"01fd0c6d","911":"5da68dbd"}[chunkId] + ".chunk.js";
};